/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 10.07.2014, 19:11
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { ConcreteEnvironment } from "./ConcreteEnvironment";
import { IEnvironment } from "./IEnvironment";

/**
 * Represents the live or production environment of the client
 */
export class LiveEnvironment extends ConcreteEnvironment implements IEnvironment {
    public static LIVE_ENVIRONMENT_ID: string = "LiveEnvironment";

    constructor(id?: string) {
        super(id !== undefined ? id : LiveEnvironment.LIVE_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        if (this._data.globals.urlVariables.forceToShowTestServers) {
            this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-netconf-test/{gameId}/{networkId}.xml";
        }
        else {
            this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-netconf/{gameId}/{networkId}.xml";
        }

        this._countryConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/country/{gameId}/{countryVersion}/country.xml";
        this._zoneCapacitiesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/network/status/{gameId}/zone_capacities.json";
        this._maintenanceConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/network/status/{gameId}/maint.json";
        this._languageConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/language/{gameId}/{languageVersion}/{languageCode}.{zipSuffix}";
        this._cldrConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/language/{gameId}/cldr";
        this._dataCookiePathPattern = BasicConstants.DOMAIN_PROTOCOL + "://data.{domain}/CookieSaver.swf";
        this._accountCookiePathPattern = BasicConstants.DOMAIN_PROTOCOL + "://account.{domain}/CookieSaver.swf";
        this._networkCookiePathPattern = BasicConstants.DOMAIN_PROTOCOL + "://ncookie.{gameFileName}.{domain}/CookieSaver.swf";

        this._versionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/version/{gameId}/version.json";
        this._itemsVersionPathPattern = "{baseURL}/ItemsVersion.properties";
        this._itemSWFURLPattern = "{baseURL}/{gameTitle}ItemLib{itemIndex}_{itemVersion}.swf";
        this._itemXMLURLPattern = "{baseURL}/config/items_v{itemsXMLVersion}.{zipSuffix}";

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/branches/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/branches/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";

        this._languagePropertiesPathPattern = "{baseURL}/{gameTitle}LangVersion.properties";
        this._fontsSWFURLPattern = "{baseURL}/fonts/{gameTitle}Fonts_{languageCode}.swf";
        this._fontsSWFURLPatternVersioned = "{baseURL}/fonts/{gameTitle}Fonts_{languageCode}_v{fontVersion}.swf";

        this._refCountURLPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/loader/refcount.php";

        this._assetsFolderPathPattern = "{baseAssetsURL}/";
        this._audiosFolderPathPattern = "{baseAssetsURL}/sound/";

        this._abTestConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/abFlash/config/abTests_{gameId}.xml";
        this._abTestTrackPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://splitrun.goodgamestudios.com/request/track";
        this._abTestDisplayPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://splitrun.goodgamestudios.com/request/display";

        this._shopPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://itemshop.goodgamestudios.com/{languageCode}/";
    }

    public isSupported(): boolean {
        return true;
    }
}
